<template>
  <v-card class="my-8 rounded-0 fill-height">
    <v-img src="../assets/education.webp" aspect-ratio="16/9" height="300"></v-img>
    <v-card-title class="text-center">AI utbildning med ChatGPT</v-card-title>
    <!-- display: block -->
    <v-card-text>
      Vår one-on-one AI-utbildning är inriktad på att hjälpa er att implementera AI på ett sätt som
      driver konkurrenskraft och framgång för ert företag. Genom vår kurs kommer ni att lära er att
      utnyttja AI-teknikens kraft för att identifiera möjligheter, optimera processer och skapa
      differentierande fördelar på marknaden.
    </v-card-text>
  </v-card>
</template>

<script>
export default {}
</script>
